/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  Box, Dialog, DialogContent, DialogTitle,
  TextField,
  MenuItem,
  Button,
} from '@material-ui/core';
import toastr from 'toastr';
import {listEndpoint, listFieldsDatabase, listParamsEndpoint} from 'api-lofty';
import {searchForReadDBRefurbished} from '../../util/searchParentComponent';
import {
  arrayDataFieldForReadComponent, cartFieldForReadComponent, databaseFieldsGetComponent, getAllFieldsForCustomParams, getFieldsBucket,
} from '../../util/databaseFieldsComponent';
import 'toastr/build/toastr.min.css';
import {restoreComponentToDefault, validDestinationForComponent} from '../../util/grapeJsCanvasFunctions';

const useStyle = makeStyles(() => ({
  titleArea: {
    padding: 0,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: '#242424',
    padding: '10px',
  },
  titleStyle: {
    marginLeft: '5px',
    color: 'rgba(255, 255, 255, 1)',
  },
  sectionsContainer: {
    padding: '10px 15px',
  },
  inputInfoContainer: {
    padding: '10px',
  },
  inputTitleInfo: {
    fontSize: '19px',
    fontWeight: 600,
    color: '#fff',
  },
}));

export default function ModalReaderCoreManager({
  data,
  localVariables,
  globalVariables,
  token,
  idProject,
  pageData,
  databases,
  open,
  onClose,
}) {
  // console.log(pageData, localVariables, globalVariables);
  const classes = useStyle();

  const [inputs, setInputs] = useState([]);
  const [paramDataCustom, setParamDataCustom] = useState([]);
  const [varCustoms, setVarCustoms] = useState([]);
  const [dbFieldsCustoms, setDbFieldsCustoms] = useState([]);

  const typesOfFields = [
    {value: 'variable', label: 'Variables'},
    {value: 'dbfield', label: 'Campo Base de Datos'},
    {value: 'useparams', label: 'Parametros'},
    {value: 'static', label: 'Estatico'},
  ];
  const [databaseSelection, setDatabaseSelection] = useState();
  const [endpointSelection, setEndpointSelection] = useState();
  const [endpointInfo, setEndpointInfo] = useState();
  const [objectDatabase, setObjectDatabase] = useState();
  // const [objectEndpoint, setObjectEndpoint] = useState();
  const [checkType, setCheckType] = useState('');
  const [fieldsOfDb, setFieldsOfDb] = useState([]);
  const [pageParams, setPageParams] = useState([]);

  // FOR BOTH
  function hasParamsInPage() {
    // const resPage = await getOnePageApiPages({token, _id: idPage});
    const urlParamsRaw = pageData.url.split('/');
    const hasParams = urlParamsRaw.some((index) => (index.includes(':')));
    return hasParams;
  }

  async function captureEndpoints(value) {
    const resEndpoint = await listEndpoint({idDatabase: value, token});
    const filterReaders = resEndpoint.data.filter((index) => (
      index.typeFunction === 'customOne'
      || index.typeFunction === 'customList'
      || index.typeFunction === 'list'
      || index.typeFunction === 'one'
    ));
    setEndpointInfo(filterReaders);
  }

  function getAllPageParams() {
    // const resPage = await getOnePageApiPages({token, _id: idPage});
    const urlParamsRaw = pageData.url.split('/');
    const filterData = [];
    urlParamsRaw.forEach((index) => {
      if (index.includes(':')) {
        const temp = index.split(':');
        const paramData = temp[1];
        filterData.push({value: paramData, name: paramData});
      }
    });
    return filterData;
  }

  async function getAllPossibleDataForCustomParams() {
    // Param Data
    const checkFirst = hasParamsInPage();
    if (checkFirst) {
      const getParamsOfPage = getAllPageParams();
      setParamDataCustom(getParamsOfPage);
    } else {
      toastr.options = {
        positionClass: 'toast-top-right',
        hideDuration: 300,
        timeOut: 6000,
      };
      toastr.clear();
      setTimeout(() => toastr.warning('La pagina no tiene parametros.'), 300);
    }

    // VARS
    const varData = [];
    localVariables.filter((index) => (index.type !== 'arrayDatabase'))
      .forEach((variable) => {
        varData.push({name: `${variable.label}--${variable.type}`, type: variable.type, value: variable._id});
      });
    globalVariables.filter((index) => (index.typeValue !== 'arrayDatabase'))
      .forEach((variable) => {
        varData.push({name: `${variable.label}--${variable.typeValue}`, type: variable.typeValue, value: variable._id});
      });
    if (varData.length > 0) {
      setVarCustoms(varData);
    } else {
      toastr.options = {
        positionClass: 'toast-top-right',
        hideDuration: 300,
        timeOut: 6000,
      };
      toastr.clear();
      setTimeout(() => toastr.warning('No se encontraron variables compatibles.'), 300);
    }

    // DB Fields
    const searchForReader = searchForReadDBRefurbished(data);
    if (searchForReader) {
      const relationFields = await getAllFieldsForCustomParams(searchForReader, token, idProject);
      setDbFieldsCustoms(relationFields);
    } else {
      toastr.options = {
        positionClass: 'toast-top-right',
        hideDuration: 300,
        timeOut: 6000,
      };
      toastr.clear();
      setTimeout(() => toastr.warning('No hay componente de lectura para campos de coleccion.'), 300);
    }
  }

  // Basic One
  const typeOfFilterOptions = [
    {name: 'Por parametros', value: 'useparams'},
    {name: 'Por Componente de Lectura', value: 'readcomponent'},
    {name: 'Por Variables', value: 'variables'},
  ];
  const [selectedFilterBasic, setSelectedFilterBasic] = useState('');
  const [currentState, setCurrentState] = useState('');
  const [valueParam, setValueParam] = useState('');
  const [varDataParam, setVarDataParam] = useState([]);

  const stateOfComponent = [
    {
      name: 'Sin Datos',
      value: 'NoDataSectionRead',
    },
    {
      name: 'Error',
      value: 'ErrorSectionRead',
    },
    {
      name: 'Con Datos',
      value: 'CoreGetDatabaseRender',
    },
    {
      name: 'Cargando',
      value: 'LoadingSectionRead',
    },
  ];

  function renderInnerComponents(component, showComponent) {
    const componentData = component.get('components');
    const hideComponents = componentData.filter((index) => (index));
    hideComponents.forEach((index) => {
      if (index.attributes.sluglofty === showComponent) {
        index.addStyle({
          display: 'block',
        });
      } else {
        index.addStyle({
          display: 'none',
        });
      }
    });
    data.addAttributes({renderComponent: showComponent});
    setCurrentState(showComponent);
  }

  async function captureFieldsForRender(endpoint, component) {
    let fieldsHtml = ''; // fields only
    let htmlAdder = ''; // Core injection

    // Capture Fields standard
    const fieldList = await listFieldsDatabase({token, idDatabase: databaseSelection, idProject});
    const filterFields = fieldList.data.filter((index) => (index.type !== 'cartArray' && index.type !== 'arrayDatabase'));
    fieldsHtml += `${databaseFieldsGetComponent(filterFields)}`;
    const filterOnlyCarts = fieldList.data.filter((index) => (index.type === 'cartArray'));
    const filterArrays = fieldList.data.filter((index) => (index.type === 'arrayDatabase'));

    if (filterArrays.length > 0) {
      const renderArrays = await arrayDataFieldForReadComponent(filterArrays, token, idProject);
      fieldsHtml += `${renderArrays}`;
    }
    if (filterOnlyCarts.length > 0) {
      const fieldsOfCart = await cartFieldForReadComponent(filterOnlyCarts, token, idProject);
      fieldsHtml += `${fieldsOfCart}`;
    }
    if (objectDatabase?.isBucket) {
      fieldsHtml += `${getFieldsBucket()}`;
    }

    // For basic list only
    if (endpoint.typeFunction === 'list') {
      htmlAdder += '<div data-gjs-slugLofty="itemListEndpointDatabase" data-gjs-name="Item List Read" style="padding: 10px;" >';
      htmlAdder += fieldsHtml;
      htmlAdder += '</div>';
      component.append(htmlAdder);
      const getModelData = component.get('components');
      const formModelData = getModelData.filter((index) => (index.attributes.sluglofty === 'itemListEndpointDatabase'));
      // console.log(formModelData[0]);
      const functionSetter = formModelData[0].attributes.components.models;
      functionSetter.forEach((index) => index.set({draggable: (e, d) => validDestinationForComponent(e, d, 'itemListEndpointDatabase')}));
    } else if (endpoint.typeFunction === 'one') {
      // buildStateForGetOne();
      htmlAdder += fieldsHtml;
      component.append(htmlAdder);
      const getModelData = component.get('components');
      getModelData.forEach((index) => index.set({draggable: (e, d) => validDestinationForComponent(e, d, 'CoreGetDatabaseRender')}));
    } else if (endpoint.typeFunction === 'customList') {
      if (endpoint?.responseType === 'listdatabase') {
        const listFieldsFromResponse = await listFieldsDatabase({token, idDatabase: endpoint?.responseDatabase, idProject});
        const filterFields = listFieldsFromResponse.data.filter((index) => (index.type !== 'cartArray' && index.type !== 'arrayDatabase'));
        let htmlAdder = `${databaseFieldsGetComponent(filterFields)}`;
        const filterOnlyCarts = listFieldsFromResponse.data.filter((index) => (index.type === 'cartArray'));
        const filterArrays = listFieldsFromResponse.data.filter((index) => (index.type === 'arrayDatabase'));
        if (filterArrays.length > 0) {
          const renderArrays = await arrayDataFieldForReadComponent(filterArrays, token, idProject);
          htmlAdder += `${renderArrays}`;
        }
        if (filterOnlyCarts.length > 0) {
          const fieldsOfCart = await cartFieldForReadComponent(filterOnlyCarts, token, idProject);
          htmlAdder += `${fieldsOfCart}`;
        }
        // const resFieldsReact = databaseFieldsGetComponent(listFieldsFromResponse.data);
        const componentCustom = `
                <div data-gjs-slugLofty="itemListEndpointDatabase" data-gjs-name="Item List Read" style="padding: 10px;" >
                  ${htmlAdder}
                  ${getFieldsBucket()}
                </div>`;
        component.append(componentCustom);
      } else if (endpoint?.responseType === 'string') {
        const componentCustom = `
                <div data-gjs-slugLofty="itemListEndpointDatabase" data-gjs-name="Item List Read" style="padding: 10px;" >
                  <div data-gjs-resizable="{bc: 1}" data-gjs-slugLofty="customListString" data-gjs-name="Texto Servicio Personalizado" data-gjs-draggable="false">
                    {{ Texto }}
                  </div>
                </div>`;
        component.append(componentCustom);
      } else if (endpoint?.responseType === 'number') {
        const componentCustom = `
                <div data-gjs-slugLofty="itemListEndpointDatabase" data-gjs-name="Item List Read" style="padding: 10px;" >
                  <div data-gjs-resizable="{bc: 1}" data-gjs-slugLofty="customListNumber" data-gjs-name="Numero Servicio Personalizado" data-gjs-draggable="false">
                    {{ Numero }}
                  </div>
                </div>`;
        component.append(componentCustom);
      } else {
        const componentCustom = `
                <div data-gjs-slugLofty="itemListEndpointDatabase" data-gjs-name="Item List Read" style="padding: 10px;" >
                  <div data-gjs-resizable="{bc: 1}" data-gjs-slugLofty="customListBoolean" data-gjs-name="Booleano Servicio Personalizado" data-gjs-draggable="false">
                    {{ Booleano }}
                  </div>
                </div>`;
        component.append(componentCustom);
      }
      const getModelData = component.get('components');
      const formModelData = getModelData.filter((index) => (index.attributes.sluglofty === 'itemListEndpointDatabase'));
      const functionSetter = formModelData[0].attributes.components.models;
      functionSetter.forEach((index) => index.set({draggable: (e, d) => validDestinationForComponent(e, d, 'itemListEndpointDatabase')}));
    } else if (endpoint.typeFunction === 'customOne') {
      const listFieldsFromResponse = await listFieldsDatabase({token, idDatabase: endpoint?.responseDatabase, idProject});
      const filterFields = listFieldsFromResponse.data.filter((index) => (index.type !== 'cartArray' && index.type !== 'arrayDatabase'));
      let htmlAdder = `${databaseFieldsGetComponent(filterFields)}`;
      const filterOnlyCarts = listFieldsFromResponse.data.filter((index) => (index.type === 'cartArray'));
      const filterArrays = listFieldsFromResponse.data.filter((index) => (index.type === 'arrayDatabase'));
      if (filterArrays.length > 0) {
        const renderArrays = await arrayDataFieldForReadComponent(filterArrays, token, idProject);
        htmlAdder += `${renderArrays}`;
      }
      if (filterOnlyCarts.length > 0) {
        const fieldsOfCart = await cartFieldForReadComponent(filterOnlyCarts, token, idProject);
        htmlAdder += `${fieldsOfCart}`;
      }
      component.append(htmlAdder);
      const getModelData = component.get('components');
      getModelData.forEach((index) => index.set({draggable: (e, d) => validDestinationForComponent(e, d, 'CoreGetDatabaseRender')}));
    }
  }

  function handleCurrentState(value) {
    const getSelectedDb = databases.find((index) => (index._id === value));
    data.addAttributes({databaseInfo: getSelectedDb, endpointDataInfo: {}});
    captureEndpoints(value);
    setObjectDatabase(getSelectedDb);
    setDatabaseSelection(value);
  }

  async function handleEndpointSelect(value) {
    const getEndpointSelected = endpointInfo.find((index) => index._id === value);
    const componentData = data.get('components');
    const internalReader = componentData.find((index) => (index.attributes.sluglofty === 'CoreGetDatabaseRender'));
    restoreComponentToDefault(internalReader);
    captureFieldsForRender(getEndpointSelected, internalReader);
    // setObjectEndpoint(getEndpointSelected);
    setEndpointSelection(getEndpointSelected._id);
    setCheckType(getEndpointSelected.typeFunction);
    data.addAttributes({endpointDataInfo: getEndpointSelected, checkTypeFunction: getEndpointSelected.typeFunction});
    if (getEndpointSelected.typeFunction === 'one') {
      data.addAttributes({typeOfFilterManager: '', oneFilterData: {}});
    }
    if (getEndpointSelected.typeFunction === 'customOne' || getEndpointSelected.typeFunction === 'customList') {
      const getParamData = await listParamsEndpoint({
        idEndpoint: getEndpointSelected._id,
        idProject,
        token,
      });
      let paramValues = [];
      if (getParamData.data.length > 0) {
        paramValues = getParamData.data.map((index) => ({
          paramendpoint: {
            value: index.name,
            label: index.label,
            type: index.type,
            stringDefaultValues: index?.stringDefaultValues || [],
          },
          state: index?.stringDefaultValues?.length > 0 ? 'static' : 'useparams',
        }));
        data.addAttributes({customParams: paramValues});
        setInputs(paramValues);
        getAllPossibleDataForCustomParams();
      } else {
        toastr.options = {
          positionClass: 'toast-top-right',
          hideDuration: 300,
          timeOut: 6000,
        };
        toastr.clear();
        setTimeout(() => toastr.warning('El servicio no tiene/requiere parametros.'), 300);
        data.addAttributes({withoutParams: 'noparamsinendpoint'});
      }
    }
  }

  async function handleTypeParamBasic(value) {
    if (value === 'useparams') {
      const checkFirst = hasParamsInPage();
      if (checkFirst) {
        const getParamsOfPage = getAllPageParams();
        setPageParams(getParamsOfPage);
        data.addAttributes({typeOfFilterOptions: value});
        setSelectedFilterBasic(value);
      } else {
        toastr.options = {
          positionClass: 'toast-top-right',
          hideDuration: 300,
          timeOut: 6000,
        };
        toastr.clear();
        setTimeout(() => toastr.error('La pagina no tiene parametros.'), 300);
      }
    }
    if (value === 'variables') {
      if (localVariables.length > 0 || globalVariables.length > 0) {
        const filterLocals = localVariables?.filter((index) => (index.type === 'database'));
        const filterGlobals = globalVariables?.filter((index) => (index.typeValue === 'database'));
        const varData = [];
        filterLocals.forEach((index) => { varData.push(index); });
        filterGlobals.forEach((index) => { varData.push(index); });
        if (varData.length > 0) {
          setVarDataParam(varData);
          data.addAttributes({typeOfFilterOptions: value});
          setSelectedFilterBasic(value);
        } else {
          toastr.options = {
            positionClass: 'toast-top-right',
            hideDuration: 300,
            timeOut: 6000,
          };
          toastr.clear();
          setTimeout(() => toastr.error('No se encontraron variables compatibles.'), 300);
        }
      } else {
        toastr.options = {
          positionClass: 'toast-top-right',
          hideDuration: 300,
          timeOut: 6000,
        };
        toastr.clear();
        setTimeout(() => toastr.error('No se encontraron variables.'), 300);
      }
    }

    if (value === 'readcomponent') {
      const searchForRead = searchForReadDBRefurbished(data);
      if (searchForRead) {
        const relationFields = await getAllFieldsForCustomParams(searchForRead, token, idProject);
        setFieldsOfDb(relationFields);
      } else {
        toastr.options = {
          positionClass: 'toast-top-right',
          hideDuration: 300,
          timeOut: 6000,
        };
        toastr.clear();
        setTimeout(() => toastr.error('No se encontro componente de lectura.'), 300);
      }
    }
  }

  function handleParamDataBasic(value, type) {
    if (type === 'useparams') {
      data.addAttributes({oneFilterData: {value, paramType: 'page'}});
      setValueParam(value);
    }
    if (type === 'variables') {
      const getSelectedVar = varDataParam.find((index) => (index._id === value));
      data.addAttributes({oneFilterData: {value, paramType: 'variableid', variableData: getSelectedVar}});
      setValueParam(value);
    }
    if (type === 'dbfield') {
      const getSelectedField = fieldsOfDb.find((index) => (index._id === value));
      data.addAttributes({oneFilterData: {value, paramType: 'field', fieldData: getSelectedField}});
      setValueParam(value);
    }
  }

  function translateTypeFunctions(type) {
    if (type === 'customOne') {
      return 'Personalizado Captura dato';
    }
    if (type === 'customList') {
      return 'Personalizado Captura de Lista';
    }
    if (type === 'list') {
      return 'Listado de datos basico';
    }
    return 'Captura de Dato basico';
  }

  // EXCLUSIVE CUSTOM PARAMS FUNCTIONS

  function editTypeInput(inputValue, typeState) {
    const temp = inputs;
    const nameValue = inputValue.paramendpoint.value;
    const indexOfObjectToUpdate = temp.findIndex((obj) => (obj.paramendpoint.value === nameValue));
    if (indexOfObjectToUpdate !== -1) {
      temp[indexOfObjectToUpdate].state = typeState;
    }
    data.addAttributes({customParams: temp});
    setInputs(temp.map((item) => item));
  }

  function editParamInput(inputValue, paramSelect) {
    try {
      const temp = inputs;
      const nameValue = inputValue.paramendpoint.value;
      const indexOfObjectToUpdate = temp.findIndex(
        (obj) => (obj.paramendpoint.value === nameValue),
      );
      if (indexOfObjectToUpdate !== -1) {
        temp[indexOfObjectToUpdate].param = paramSelect;
      }
      data.addAttributes({customParams: temp});
      setInputs(temp.map((item) => item));
      toastr.options = {
        positionClass: 'toast-top-right',
        hideDuration: 300,
        timeOut: 6000,
      };
      toastr.clear();
      setTimeout(() => toastr.success('Se actualizo el valor del parametro personalizado'), 300);
    } catch (error) {
      toastr.options = {
        positionClass: 'toast-top-right',
        hideDuration: 300,
        timeOut: 6000,
      };
      toastr.clear();
      setTimeout(() => toastr.error('No se actualizo la informacion'), 300);
    }
  }

  function checkTypeOf(paramValue, compareTo) {
    if (paramValue === 'string' && (compareTo === 'string' || compareTo === 'database' || compareTo === 'relation')) {
      return true;
    }
    if (paramValue === compareTo) {
      return true;
    }
    return false;
  }

  function checkTypeDb(paramValue, compareTo) {
    if (paramValue === 'db' && compareTo === 'database') {
      return true;
    }
    return false;
  }

  useEffect(async () => {
    try {
      // console.log(data);
      // Capture Basic Data
      if (data?.attributes?.attributes?.databaseInfo) {
        setDatabaseSelection(data.attributes.attributes.databaseInfo._id);
        captureEndpoints(data.attributes.attributes.databaseInfo._id);
      }
      if (data?.attributes?.attributes?.endpointDataInfo?._id) {
        setEndpointSelection(data.attributes.attributes.endpointDataInfo._id);
      }
      if (data?.attributes?.attributes?.renderComponent) {
        setCurrentState(data.attributes.attributes.renderComponent);
      }

      if (data?.attributes?.attributes?.checkTypeFunction) {
        setCheckType(data.attributes.attributes.checkTypeFunction);
      }

      if (data?.attributes?.attributes?.customParams) {
        setInputs(data?.attributes?.attributes?.customParams);
        getAllPossibleDataForCustomParams();
      }

      if (data?.attributes?.attributes?.typeOfFilterOptions) {
        setSelectedFilterBasic(data.attributes.attributes.typeOfFilterOptions);
        if (data.attributes.attributes.typeOfFilterOptions === 'useparams') {
          const getParamsOfPage = getAllPageParams();
          setPageParams(getParamsOfPage);
        }
        if (data.attributes.attributes.typeOfFilterOptions === 'variables') {
          const filterLocals = localVariables?.filter((index) => (index.type === 'database'));
          const filterGlobals = globalVariables?.filter((index) => (index.typeValue === 'database'));
          const varData = [];
          filterLocals.forEach((index) => { varData.push(index); });
          filterGlobals.forEach((index) => { varData.push(index); });
          setVarDataParam(varData);
        }
      }

      if (data?.attributes?.attributes?.oneFilterData) {
        setValueParam(data.attributes.attributes.oneFilterData.value);
      }
    } catch (error) {
      // console.log(error);
    }
  }, [data, open, databases]);

  function handleClose() {
    setCurrentState('');
    setDatabaseSelection('');
    setCheckType('');
    setDatabaseSelection('');
    setDbFieldsCustoms([]);
    setInputs([]);
    setEndpointInfo([]);
    setPageParams([]);
    setParamDataCustom([]);
    setFieldsOfDb([]);
    setObjectDatabase([]);
    setValueParam('');
    setVarDataParam([]);
    setSelectedFilterBasic('');
    onClose();
  }

  return (
    <Dialog open={open} onClose={() => handleClose()} fullWidth maxWidth="lg">
      <DialogTitle className={classes.titleArea}>
        <Box className={classes.titleContainer}>
          <Box className={classes.titleStyle}>
            Manejar Componente de Lectura de Datos
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent style={{background: '#242424', color: '#fff'}}>
        <Box className={classes.sectionsContainer}>
          <Box className={classes.inputInfoContainer}>
            <Box component="div" className={classes.inputTitleInfo}>
              Estado del Componente
            </Box>
            <TextField
              onChange={(e) => renderInnerComponents(data, e.target.value)}
              value={currentState}
              select
              fullWidth
              name="type"
              type="text"
              label="Estado:"
              variant="standard"
              style={{backgroundColor: '#D9D9D9', color: '#fff'}}
            >
              {
                stateOfComponent.map(({name, value}) => (
                  <MenuItem value={value} key={value}>
                    {name}
                  </MenuItem>
                ))
              }
            </TextField>
          </Box>
        </Box>
        <Box style={{display: 'block'}}>
          {/* MAIN OPTIONS TO CONFIGURE COMPONENT */}
          <Box className={classes.sectionsContainer}>
            <Box className={classes.inputInfoContainer}>
              <Box component="div" className={classes.inputTitleInfo}>
                Colecciones de Datos
              </Box>
              <TextField
                onChange={(e) => handleCurrentState(e.target.value)}
                value={databaseSelection}
                select
                fullWidth
                name="type"
                type="text"
                label="Seleccion de Base De Datos:"
                variant="standard"
                style={{backgroundColor: '#D9D9D9', color: '#fff'}}
              >
                {
                  databases.map((index) => (
                    <MenuItem value={index._id} key={index._id}>
                      {index.label}
                    </MenuItem>
                  ))
                }
              </TextField>
            </Box>
            {
                databaseSelection && endpointInfo && (
                  <Box className={classes.inputInfoContainer}>
                    <Box component="div" className={classes.inputTitleInfo}>
                      Servicios
                    </Box>
                    <TextField
                      onChange={(e) => handleEndpointSelect(e.target.value)}
                      value={endpointSelection}
                      select
                      fullWidth
                      name="type"
                      type="text"
                      label="Seleccion de Servicios:"
                      variant="standard"
                      style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                    >
                      {
                        endpointInfo?.map((index) => (
                          <MenuItem value={index._id} key={index._id}>
                            {translateTypeFunctions(index.typeFunction)}
                            {' '}
                            {index.url}
                            {' '}
                            {index?.label ? `- ${index?.label}` : ''}
                          </MenuItem>
                        ))
                      }
                    </TextField>
                  </Box>
                )
              }
            {/*
               ------------------- FOR BASIC GET ---------------------
            */}
            {
              endpointSelection && checkType === 'one' && (
                <Box className={classes.inputInfoContainer}>
                  <Box component="div" className={classes.inputTitleInfo}>
                    Tipo de Parametro
                  </Box>
                  <TextField
                    onChange={(e) => handleTypeParamBasic(e.target.value)}
                    value={selectedFilterBasic}
                    select
                    fullWidth
                    name="type"
                    type="text"
                    label="Seleccion de Tipo de Parametro:"
                    variant="standard"
                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                  >
                    {
                        typeOfFilterOptions?.map((index) => (
                          <MenuItem value={index.value} key={index.value}>
                            {index.name}
                          </MenuItem>
                        ))
                      }
                  </TextField>
                </Box>
              )
            }
            {
              endpointSelection && checkType && selectedFilterBasic === 'useparams' && (
                <Box className={classes.inputInfoContainer}>
                  <Box component="div" className={classes.inputTitleInfo}>
                    Parametros de Pagina
                  </Box>
                  <TextField
                    onChange={(e) => handleParamDataBasic(e.target.value, 'useparams')}
                    value={valueParam}
                    select
                    fullWidth
                    name="type"
                    type="text"
                    label="Parametros de Pagina:"
                    variant="standard"
                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                  >
                    {
                        pageParams?.map((index) => (
                          <MenuItem value={index.value} key={index.value}>
                            {index.name}
                          </MenuItem>
                        ))
                      }
                  </TextField>
                </Box>
              )
            }
            {
              endpointSelection && checkType && selectedFilterBasic === 'variables' && (
                <Box className={classes.inputInfoContainer}>
                  <Box component="div" className={classes.inputTitleInfo}>
                    Variables
                  </Box>
                  <TextField
                    onChange={(e) => handleParamDataBasic(e.target.value, 'variables')}
                    value={valueParam}
                    select
                    fullWidth
                    name="type"
                    type="text"
                    label="Variables:"
                    variant="standard"
                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                  >
                    {
                        varDataParam?.map((index) => (
                          <MenuItem value={index._id} key={index._id}>
                            {index.label}
                            {' '}
                            {index?.type ? '-- Local' : '-- Global'}
                          </MenuItem>
                        ))
                      }
                  </TextField>
                </Box>
              )
            }
            {
              endpointSelection && checkType && selectedFilterBasic === 'dbfield' && (
                <Box className={classes.inputInfoContainer}>
                  <Box component="div" className={classes.inputTitleInfo}>
                    Campos de Coleccion
                  </Box>
                  <TextField
                    onChange={(e) => handleParamDataBasic(e.target.value, 'dbfield')}
                    value={valueParam}
                    select
                    fullWidth
                    name="type"
                    type="text"
                    label="Campos:"
                    variant="standard"
                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                  >
                    {
                      fieldsOfDb?.filter(
                        (fieldData) => (checkTypeDb('db', fieldData.type)),
                      )?.map(({value, name}) => (
                        <MenuItem value={value} key={value}>
                          {name}
                        </MenuItem>
                      ))
                    }
                  </TextField>
                </Box>
              )
            }
            {/*
              ----------------------------- FOR CUSTOMS -----------------------------------------
            */}
            {
              endpointSelection && checkType.includes('custom') && inputs?.length > 0 && (
                <Box
                  component="div"
                  style={{
                    margin: '15px', padding: '5px', height: '400px', overflowY: 'scroll',
                  }}
                >
                  {
                          inputs.map((index) => (
                            <Box component="div" className={classes.inputInfoContainer} key={index}>
                              <Box component="div" className={classes.inputTitleInfo}>
                                {index.paramendpoint.label}
                              </Box>
                              <div className="my-4">
                                <TextField
                                  onChange={(e) => editTypeInput(index, e.target.value)}
                                  value={index.state}
                                  select
                                  fullWidth
                                  name="type"
                                  type="text"
                                  label="Usar Parametro con:"
                                  variant="standard"
                                  style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                                >
                                  {
                                      typesOfFields.map(({label, value}) => (
                                        <MenuItem value={value} key={value}>
                                          {label}
                                        </MenuItem>
                                      ))
                                    }
                                </TextField>
                              </div>
                              {index.state === 'useparams' && (
                                <div>
                                  <TextField
                                    select
                                    fullWidth
                                    name="type"
                                    onChange={(e) => editParamInput(index, e.target.value)}
                                    value={index?.param}
                                    type="text"
                                    label="Parametros:"
                                    variant="standard"
                                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                                  >
                                    {
                                      paramDataCustom?.map(({value, name}) => (
                                        <MenuItem value={value} key={value}>
                                          {name}
                                        </MenuItem>
                                      ))
                                    }
                                  </TextField>
                                </div>
                              )}
                              {index.state === 'variable' && (
                                <div>
                                  <TextField
                                    select
                                    fullWidth
                                    name="type"
                                    onChange={(e) => editParamInput(index, e.target.value)}
                                    value={index?.param}
                                    type="text"
                                    label="Parametros:"
                                    variant="standard"
                                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                                  >
                                    {
                                      varCustoms?.filter(
                                        (fieldData) => (checkTypeOf(index.paramendpoint.type, fieldData.type)),
                                      )?.map(({value, name}) => (
                                        <MenuItem value={value} key={value}>
                                          {name}
                                        </MenuItem>
                                      ))
                                    }
                                  </TextField>
                                </div>
                              )}
                              {index.state === 'dbfield' && (
                                <div>
                                  <TextField
                                    select
                                    fullWidth
                                    name="type"
                                    onChange={(e) => editParamInput(index, e.target.value)}
                                    value={index?.param}
                                    type="text"
                                    label="Parametros:"
                                    variant="standard"
                                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                                  >
                                    {
                                      dbFieldsCustoms?.filter(
                                        (fieldData) => (checkTypeOf(index.paramendpoint.type, fieldData.type)),
                                      )?.map(({value, name}) => (
                                        <MenuItem value={value} key={value}>
                                          {name}
                                        </MenuItem>
                                      ))
                                    }
                                  </TextField>
                                </div>
                              )}
                              {index.state === 'static' && (index?.paramendpoint?.stringDefaultValues.length > 0) && (
                                <div>
                                  <TextField
                                    select
                                    fullWidth
                                    name="type"
                                    onChange={(e) => editParamInput(index, e.target.value)}
                                    value={index?.param}
                                    type="text"
                                    label="Valor por defecto:"
                                    variant="standard"
                                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                                  >
                                    {
                                      index?.paramendpoint?.stringDefaultValues?.map(({label, slug}) => (
                                        <MenuItem value={slug} key={slug}>
                                          {label}
                                        </MenuItem>
                                      ))
                                    }
                                  </TextField>
                                </div>
                              )}
                              {index.state === 'static' && (!index?.paramendpoint?.stringDefaultValues || index?.paramendpoint?.stringDefaultValues.length === 0) && (
                                <div>
                                  <TextField
                                    fullWidth
                                    name="type"
                                    onChange={(e) => editParamInput(index, e.target.value)}
                                    value={index?.param}
                                    type="text"
                                    label="Valor estatico:"
                                    variant="standard"
                                    style={{backgroundColor: '#D9D9D9', color: '#fff'}}
                                  />
                                </div>
                              )}
                            </Box>
                          ))
                        }
                </Box>
              )
            }
          </Box>
        </Box>
        <Box className={classes.buttonAreaContainer}>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => handleClose()}
            className={classes.buttonStyle}
          >
            Cerrar
          </Button>
          {/* <Button
            onClick={() => saveToComponent()}
            startIcon={<Save />}
            variant="contained"
            color="primary"
            style={{marginLeft: '10px'}}
          >
            Guardar
          </Button> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
